/**
 * @packageDocumentation
 * @module dom/attribute
 */

import { joinWith, attrListRegExp } from '../core/util';
import set_attr from './set_attr';
import is_node from '../is/is_node';

export interface IncludeAttrList {
  /**
   * include a value on an attribute list
   * @param el the element to toggle an attribute list
   * @param name the attribute name to target and manage
   * @param value the value to include
   */
  (el: Element, name: string, value: string): Element;
}

/**
 * { @link IncludeAttrList }
 */
export default (el: Element, name: string, value: string) => {
  if (!is_node(el)) {
    return el;
  }

  const existingList = (el.getAttribute(name) ?? '').split(attrListRegExp) || [];
  const newList = (value ?? '').split(attrListRegExp) || [];
  const fullList = [...existingList, ...newList].filter((v) => v).map((v) => v.trim());
  const uniqueList = Array.from(new Set(fullList));

  set_attr(el, name, uniqueList.join(joinWith(name)));
  return el;
};
